import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const LOCATIONMANAGER_REQUEST = 'LOCATIONMANAGER_REQUEST';
export const LOCATIONMANAGER_SUCCESS = 'LOCATIONMANAGER_SUCCESS';
export const LOCATIONMANAGER_FAILURE = 'LOCATIONMANAGER_FAILURE';

export const LOCATION_REQUEST = 'LOCATION_REQUEST';
export const LOCATION_SUCCESS = 'LOCATION_SUCCESS';
export const LOCATION_FAILURE = 'LOCATION_FAILURE';

export const LOCATION_UPDATE_REQUEST = 'LOCATION_UPDATE_REQUEST';
export const LOCATION_UPDATE_SUCCESS = 'LOCATION_UPDATE_SUCCESS';
export const LOCATION_UPDATE_FAILURE = 'LOCATION_UPDATE_FAILURE';

export const SHUTDOWN_HOURS_REQUEST = 'SHUTDOWN_HOURS_REQUEST';
export const SHUTDOWN_HOURS_SUCCESS = 'SHUTDOWN_HOURS_SUCCESS';
export const SHUTDOWN_HOURS_FAILURE = 'SHUTDOWN_HOURS_FAILURE';

export const LOCATION_UPDATE_SHUTDOWN_HOURS_REQUEST = 'LOCATION_UPDATE_SHUTDOWN_HOURS_REQUEST';
export const LOCATION_UPDATE_SHUTDOWN_HOURS_SUCCESS = 'LOCATION_UPDATE_SHUTDOWN_HOURS_SUCCESS';
export const LOCATION_UPDATE_SHUTDOWN_HOURS_FAILURE = 'LOCATION_UPDATE_SHUTDOWN_HOURS_FAILURE';

export const LOCATION_DETAILS_REQUEST = 'LOCATION_DETAILS_REQUEST';
export const LOCATION_DETAILS_SUCCESS = 'LOCATION_DETAILS_SUCCESS';
export const LOCATION_DETAILS_FAILURE = 'LOCATION_DETAILS_FAILURE';

export const TEAM_NAMES_REQUEST = 'TEAM_NAMES_REQUEST';
export const TEAM_NAMES_SUCCESS = 'TEAM_NAMES_SUCCESS';
export const TEAM_NAMES_FAILURE = 'TEAM_NAMES_FAILURE';

export const ACTIVITY_STATUSES_REQUEST = 'ACTIVITY_STATUSES_REQUEST';
export const ACTIVITY_STATUSES_SUCCESS = 'ACTIVITY_STATUSES_SUCCESS';
export const ACTIVITY_STATUSES_FAILURE = 'ACTIVITY_STATUSES_FAILURE';

export const LOCATION_GET_FILES_REQUEST = 'LOCATION_GET_FILES_REQUEST';
export const LOCATION_GET_FILES_SUCCESS = 'LOCATION_GET_FILES_SUCCESS';
export const LOCATION_GET_FILES_FAILURE = 'LOCATION_GET_FILES_FAILURE';

export const LOCATION_UPLOAD_FILES_REQUEST = 'LOCATION_UPLOAD_FILES_REQUEST';
export const LOCATION_UPLOAD_FILES_SUCCESS = 'LOCATION_UPLOAD_FILES_SUCCESS';
export const LOCATION_UPLOAD_FILES_FAILURE = 'LOCATION_UPLOAD_FILES_FAILURE';

export const LOCATION_GET_FILE_REQUEST = 'LOCATION_GET_FILE_REQUEST';
export const LOCATION_GET_FILE_SUCCESS = 'LOCATION_GET_FILE_SUCCESS';
export const LOCATION_GET_FILE_FAILURE = 'LOCATION_GET_FILE_FAILURE';

export const LOCATION_DELETE_FILE_REQUEST = 'LOCATION_DELETE_FILE_REQUEST';
export const LOCATION_DELETE_FILE_SUCCESS = 'LOCATION_DELETE_FILE_SUCCESS';
export const LOCATION_DELETE_FILE_FAILURE = 'LOCATION_DELETE_FILE_FAILURE';

export const LOCATION_TYPEAHEAD_REQUEST = 'LOCATION_TYPEAHEAD_REQUEST';
export const LOCATION_TYPEAHEAD_SUCCESS = 'LOCATION_TYPEAHEAD_SUCCESS';
export const LOCATION_TYPEAHEAD_FAILURE = 'LOCATION_TYPEAHEAD_FAILURE';

export const CLINIC_GET_FILES_REQUEST = 'CLINIC_GET_FILES_REQUEST';
export const CLINIC_GET_FILES_SUCCESS = 'CLINIC_GET_FILES_SUCCESS';
export const CLINIC_GET_FILES_FAILURE = 'CLINIC_GET_FILES_FAILURE';

export const CLINIC_UPLOAD_FILES_REQUEST = 'CLINIC_UPLOAD_FILES_REQUEST';
export const CLINIC_UPLOAD_FILES_SUCCESS = 'CLINIC_UPLOAD_FILES_SUCCESS';
export const CLINIC_UPLOAD_FILES_FAILURE = 'CLINIC_UPLOAD_FILES_FAILURE';

export const CLINIC_GET_FILE_REQUEST = 'CLINIC_GET_FILE_REQUEST';
export const CLINIC_GET_FILE_SUCCESS = 'CLINIC_GET_FILE_SUCCESS';
export const CLINIC_GET_FILE_FAILURE = 'CLINIC_GET_FILE_FAILURE';

export const CLINIC_DELETE_FILE_REQUEST = 'CLINIC_DELETE_FILE_REQUEST';
export const CLINIC_DELETE_FILE_SUCCESS = 'CLINIC_DELETE_FILE_SUCCESS';
export const CLINIC_DELETE_FILE_FAILURE = 'CLINIC_DELETE_FILE_FAILURE';

export const CLINIC_PREVIEW_FILE_REQUEST = 'CLINIC_PREVIEW_FILE_REQUEST';
export const CLINIC_PREVIEW_FILE_SUCCESS = 'CLINIC_PREVIEW_FILE_SUCCESS';
export const CLINIC_PREVIEW_FILE_FAILURE = 'CLINIC_PREVIEW_FILE_FAILURE';

export const CLINIC_UPDATE_FILE_REQUEST = 'CLINIC_UPDATE_FILE_REQUEST';
export const CLINIC_UPDATE_FILE_SUCCESS = 'CLINIC_UPDATE_FILE_SUCCESS';
export const CLINIC_UPDATE_FILE_FAILURE = 'CLINIC_UPDATE_FILE_FAILURE';

export const LOCATION_COUNT_REQUEST = 'LOCATION_COUNT_REQUEST';
export const LOCATION_COUNT_SUCCESS = 'LOCATION_COUNT_SUCCESS';
export const LOCATION_COUNT_FAILURE = 'LOCATION_COUNT_FAILURE';

export const FACILITY_GET_FILES_REQUEST = 'FACILITY_GET_FILES_REQUEST';
export const FACILITY_GET_FILES_SUCCESS = 'FACILITY_GET_FILES_SUCCESS';
export const FACILITY_GET_FILES_FAILURE = 'FACILITY_GET_FILES_FAILURE';

export const FACILITY_UPLOAD_FILES_REQUEST = 'FACILITY_UPLOAD_FILES_REQUEST';
export const FACILITY_UPLOAD_FILES_SUCCESS = 'FACILITY_UPLOAD_FILES_SUCCESS';
export const FACILITY_UPLOAD_FILES_FAILURE = 'FACILITY_UPLOAD_FILES_FAILURE';

export const FACILITY_UPDATE_FILE_REQUEST = 'FACILITY_UPDATE_FILE_REQUEST';
export const FACILITY_UPDATE_FILE_SUCCESS = 'FACILITY_UPDATE_FILE_SUCCESS';
export const FACILITY_UPDATE_FILE_FAILURE = 'FACILITY_UPDATE_FILE_FAILURE';

export const ZIPCODE_REQUEST = 'ZIPCODE_REQUEST';
export const ZIPCODE_SUCCESS = 'ZIPCODE_SUCCESS';
export const ZIPCODE_FAILURE = 'ZIPCODE_FAILURE';

export function requestLocations(params = {}) {
  const query = $.param(params);
  return { 
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/search/clinic-locations?${query}`,
      method: 'GET',
      types: ['LOCATIONMANAGER_REQUEST', 'LOCATIONMANAGER_SUCCESS', 'LOCATIONMANAGER_FAILURE']
    }
  };
}

export function requestLocationsDashboard(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/search/clinic-locations-dashboard?${query}`,
      method: 'GET',
      types: ['LOCATIONMANAGER_REQUEST', 'LOCATIONMANAGER_SUCCESS', 'LOCATIONMANAGER_FAILURE']
    }
  };
}

export function requestLocationDetails(clinicLocationID, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic-locations/${clinicLocationID}/detail?${query}`,
      method: 'GET',
      types: [
        { type: 'LOCATION_DETAILS_REQUEST', meta: { clinicLocationID } },
        { type: 'LOCATION_DETAILS_SUCCESS', meta: { clinicLocationID } },
        { type: 'LOCATION_DETAILS_FAILURE', meta: { clinicLocationID } },
      ]
    }
  }
}

export function updateLocationDetails(location, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic-locations/${location.clinicLocationID}?${query}`,
      method: 'POST',
      body: JSON.stringify(location),
      types: ["LOCATION_UPDATE_REQUEST", "LOCATION_UPDATE_SUCCESS", "LOCATION_UPDATE_FAILURE"]
    }
  }
}

export function requestTeamNames(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/team-names/all?${query}`,
      method: 'GET',
      types: [
        'TEAM_NAMES_REQUEST',
        'TEAM_NAMES_SUCCESS',
        'TEAM_NAMES_FAILURE',
      ]
    }
  }
}

export function requestActivityStatuses(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/activity-statuses/all?${query}`,
      method: 'GET',
      types: [
        'ACTIVITY_STATUSES_REQUEST',
        'ACTIVITY_STATUSES_SUCCESS',
        'ACTIVITY_STATUSES_FAILURE',
      ]
    }
  }
}

export function requestLocationPhotoGalleryFiles(locationCode, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/${locationCode}/photo-gallery/files?${query}`,
      method: 'GET',
      types: [
        { type: 'LOCATION_GET_FILES_REQUEST', meta: { locationCode } },
        { type: 'LOCATION_GET_FILES_SUCCESS', meta: { locationCode } },
        { type: 'LOCATION_GET_FILES_FAILURE', meta: { locationCode } },
      ]
    }
  };
}

export function uploadLocationPhotoGalleryFiles(locationCode, params, htmlFiles = []) {
  const query = $.param(params);
  const data = new FormData();

  htmlFiles.forEach((file) => data.append('files', file));

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/${locationCode}/photo-gallery/files?${query}`,
      method: 'POST',
      headers: {},
      body: data,
      types: ['LOCATION_UPLOAD_FILES_REQUEST', 'LOCATION_UPLOAD_FILES_SUCCESS', 'LOCATION_UPLOAD_FILES_FAILURE']
    },
  };
}

export function getLocationPhotoGalleryFile(locationCode, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/${locationCode}/photo-gallery/files/${fileName}/?${query}`,
      method: 'GET',
      headers: { },
      types: [
        'LOCATION_GET_FILE_REQUEST',
        {
          type: 'LOCATION_GET_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          }
        },
        'LOCATION_GET_FILE_FAILURE']
    },
  };
}

export function deleteLocationPhotoGalleryFile(locationCode, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/${locationCode}/photo-gallery/files/${fileName}/?${query}`,
      method: 'DELETE',
      types: ['LOCATION_DELETE_FILE_REQUEST', 'LOCATION_DELETE_FILE_SUCCESS', 'LOCATION_DELETE_FILE_FAILURE']
    },
  };
}

export function requestClinicLocationsTypeahead(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic-locations/typeahead?${query}`,
      method: 'GET',
      types: ['LOCATION_TYPEAHEAD_REQUEST', 'LOCATION_TYPEAHEAD_SUCCESS', 'LOCATION_TYPEAHEAD_FAILURE']
    }
  };
}

export function requestShutdownHours(clinicLocationID, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic-location/${clinicLocationID}/shutdown-hours?${query}`,
      method: 'GET',
      types: ["SHUTDOWN_HOURS_REQUEST", "SHUTDOWN_HOURS_SUCCESS", "SHUTDOWN_HOURS_FAILURE"]
    },
  };
}

export function updateShutdownHours(clinicLocationID, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic-location/shutdown-hours?${query}`,
      method: 'POST',
      body: JSON.stringify(clinicLocationID),
      types: ["LOCATION_UPDATE_SHUTDOWN_HOURS_REQUEST", "LOCATION_UPDATE_SHUTDOWN_HOURS_SUCCESS", "LOCATION_UPDATE_SHUTDOWN_HOURS_FAILURE"]
    }
  }
}

export function requestLocationFiles(locationCode, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/${locationCode}/files?${query}`,
      method: 'GET',
      types: [
        { type: 'CLINIC_GET_FILES_REQUEST', meta: { locationCode } },
        { type: 'CLINIC_GET_FILES_SUCCESS', meta: { locationCode } },
        { type: 'CLINIC_GET_FILES_FAILURE', meta: { locationCode } },
      ]
    }
  };
}

export function uploadLocationFiles(locationCode, params, htmlFiles = []) {
  const query = $.param(params);
  const data = new FormData();

  htmlFiles.forEach((file) => data.append('files', file));

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/${locationCode}/files?${query}`,
      method: 'POST',
      headers: {},
      body: data,
      types: ['CLINIC_UPLOAD_FILES_REQUEST', 'CLINIC_UPLOAD_FILES_SUCCESS', 'CLINIC_UPLOAD_FILES_FAILURE']
    },
  };
}

export function getLocationFile(locationCode, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/${locationCode}/files/${fileName}/?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'CLINIC_GET_FILE_REQUEST',
        {
          type: 'CLINIC_GET_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          }
        },
        'CLINIC_GET_FILE_FAILURE']
    },
  };
}

export function deleteLocationFile(locationCode, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/${locationCode}/files/${fileName}/?${query}`,
      method: 'DELETE',
      types: ['CLINIC_DELETE_FILE_REQUEST', 'CLINIC_DELETE_FILE_SUCCESS', 'CLINIC_DELETE_FILE_FAILURE']
    },
  };
}

export function previewLocationFile(locationCode, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/preview/${locationCode}/files/${fileName}/?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'CLINIC_PREVIEW_FILE_REQUEST',
        {
          type: 'CLINIC_PREVIEW_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          },
        },
        'CLINIC_PREVIEW_FILE_FAILURE']
    }
  };
}

export function updateLocationFileDescription(locationCode, fileName, params, data) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/${locationCode}/files/${fileName}/description?${query}`,
      method: 'POST',
      body: JSON.stringify(data),
      types: ['CLINIC_UPDATE_FILE_REQUEST', 'CLINIC_UPDATE_FILE_SUCCESS', 'CLINIC_UPDATE_FILE_FAILURE']
    },
  };
}

export function requestDashboardMetricsCount(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/search/dashboard-metrics-count?${query}`,
      method: 'GET',
      types: ['LOCATION_COUNT_REQUEST', 'LOCATION_COUNT_SUCCESS', 'LOCATION_COUNT_FAILURE']
    }
  };
}

export function requestLocationFacilityFiles(locationCode, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/facility/${locationCode}/files?${query}`,
      method: 'GET',
      types: [
        { type: 'FACILITY_GET_FILES_REQUEST', meta: { locationCode } },
        { type: 'FACILITY_GET_FILES_SUCCESS', meta: { locationCode } },
        { type: 'FACILITY_GET_FILES_FAILURE', meta: { locationCode } },
      ]
    }
  };
}

export function uploadLocationFacilityFiles(locationCode, params, htmlFiles = []) {
  const query = $.param(params);
  const data = new FormData();

  htmlFiles.forEach((file) => data.append('files', file));

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/facility/${locationCode}/files?${query}`,
      method: 'POST',
      headers: {},
      body: data,
      types: ['FACILITY_UPLOAD_FILES_REQUEST', 'FACILITY_UPLOAD_FILES_SUCCESS', 'FACILITY_UPLOAD_FILES_FAILURE']
    },
  };
}

export function getFacilityFile(locationCode, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/facility/${locationCode}/files/${fileName}/?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'FACILITY_GET_FILE_REQUEST',
        {
          type: 'FACILITY_GET_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          }
        },
        'FACILITY_GET_FILE_FAILURE']
    },
  };
}

export function previewFacilityFile(locationCode, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/facility/preview/${locationCode}/files/${fileName}/?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'FACILITY_PREVIEW_FILE_REQUEST',
        {
          type: 'FACILITY_PREVIEW_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          },
        },
        'FACILITY_PREVIEW_FILE_FAILURE']
    }
  };
}

export function deleteFacilityFile(locationCode, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/facility/${locationCode}/files/${fileName}/?${query}`,
      method: 'DELETE',
      types: ['FACILITY_DELETE_FILE_REQUEST', 'FACILITY_DELETE_FILE_SUCCESS', 'FACILITY_DELETE_FILE_FAILURE']
    },
  };
}

export function updateFacilityFileInfo(locationCode, fileName, params, data) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinics/facility/${locationCode}/files/${fileName}/description?${query}`,
      method: 'POST',
      body: JSON.stringify(data),
      types: ['FACILITY_UPDATE_FILE_REQUEST', 'FACILITY_UPDATE_FILE_SUCCESS', 'FACILITY_UPDATE_FILE_FAILURE']
    },
  };
}

export function requestZipCodeForLocation(location, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/zipcode-for-location/${location.provider.code}?${query}`,
      method: 'GET',
      types: ["ZIPCODE_REQUEST", "ZIPCODE_SUCCESS", "ZIPCODE_FAILURE"]
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/location-manager/LocationManagerActions.js